import { MetadataField } from '../../../../../../../../../constnats/reportConstants';
import ObjCheck from '../../../../../../../../../utils/objCheck';
import { ERROR_PROMPTING_IMPACT_FIELD_PROPS } from '../../../../../../constants/generalConstants';
import { ImpactType } from '../../../../../../types';

type DescriptorToPropsMapType = { [descriptorId: string]: Set<string> };

type ReportDiff = {
    originalValue: any;
    modifiedValue: any;
};

type ReportToPropDiffMapType = { [reportId: number]: ReportDiff };
type PropType = {
    propName: string;
    reportToPropDiff: ReportToPropDiffMapType;
};

type DescriptorDiffsType = {
    descriptorId: string;
    props: PropType[];
};

type TableModelType = { rows: DescriptorDiffsType[] };

function getDescriptorToPropsMap(impact: ImpactType): DescriptorToPropsMapType {
    const descriptorToProps: DescriptorToPropsMapType = {};
    for (const reportDiff of impact.updatedReports) {
        for (const fieldDiff of reportDiff.diffs) {
            const descriptorId = fieldDiff.descriptorId;

            if (!descriptorToProps[descriptorId]) {
                descriptorToProps[descriptorId] = new Set<string>();
            }

            for (const fieldPropDiff of fieldDiff.diffs) {
                descriptorToProps[descriptorId].add(fieldPropDiff.propName);
            }
        }
    }

    return descriptorToProps;
}

const PROPERTIES_TO_IGNORE = [MetadataField.INPUT_SCALE];

export function getImpactTableModel(impact: ImpactType): TableModelType {
    const descriptorToProps = getDescriptorToPropsMap(impact);
    const reportIds = impact.updatedReports.map((reportDiff) => reportDiff.id);

    const tableModel: TableModelType = {
        rows: Object.entries(descriptorToProps).map(([descriptorId, propsSet]) => {
            const properties = Array.from(propsSet);
            const descriptor: DescriptorDiffsType = {
                descriptorId,
                props: properties
                    .filter((propName) => !PROPERTIES_TO_IGNORE.includes(propName))
                    .map((propName) => {
                        return {
                            propName,
                            reportToPropDiff: reportIds.reduce((acc, reportId) => {
                                const report = impact.updatedReports.find((r) => r.id === reportId);
                                const fieldDiff = report?.diffs.find((fd) => fd.descriptorId === descriptorId);
                                const propDiff = fieldDiff?.diffs.find((pd) => pd.propName === propName);

                                acc[reportId] = {
                                    originalValue: propDiff?.originalValue,
                                    modifiedValue: propDiff?.modifiedValue,
                                };

                                return acc;
                            }, {} as ReportToPropDiffMapType),
                        };
                    }),
            };

            return descriptor;
        }),
    };

    return tableModel;
}

export function hasErrorPromptingFieldProps(impact: ImpactType): boolean {
    return impact.updatedReports.some((report) =>
        report.diffs.some((fieldDiff) =>
            fieldDiff.diffs.some((propDiff) => ERROR_PROMPTING_IMPACT_FIELD_PROPS.includes(propDiff.propName))
        )
    );
}

export function getReportCellClasses(fieldProp: string, originalValue: any, modifiedValue: any): string {
    let classes = '';
    if (
        ERROR_PROMPTING_IMPACT_FIELD_PROPS.includes(fieldProp) &&
        !ObjCheck.isNullUndefinedOrEmpty(originalValue) &&
        !ObjCheck.isNullUndefinedOrEmpty(modifiedValue)
    ) {
        classes = `${classes} warning`;
    }

    return classes;
}
